"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var RemainingChars_1 = require("components/RemainingChars");
var styles = __importStar(require("./TextArea.module.css"));
var TextArea = (function (_super) {
    __extends(TextArea, _super);
    function TextArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextArea.prototype.render = function () {
        var _a = this.props, id = _a.id, json_data = _a.json_data, onChange = _a.onChange, rows = _a.rows, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors, maxLength = _a.maxLength, className = _a.className;
        var value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root + " " + className;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("textarea", { rows: rows, className: css, id: id, value: value, onChange: function (event) {
                    onChange(id, event.target.value);
                }, placeholder: placeholder, disabled: disabled, maxLength: maxLength }),
            maxLength && !window.isPdf && (react_1.default.createElement(RemainingChars_1.RemainingChars, { maxLength: maxLength, value: value })),
            error && react_1.default.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    TextArea.defaultProps = {
        rows: 5,
        errors: {}
    };
    return TextArea;
}(react_1.Component));
exports.TextArea = TextArea;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dEFyZWEuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1RleHRBcmVhL1RleHRBcmVhLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBRXRDLDREQUF3RDtBQUN4RCw0REFBK0M7QUFjL0M7SUFBOEIsNEJBQW9CO0lBQWxEOztJQStDQSxDQUFDO0lBekNVLHlCQUFNLEdBQWI7UUFDVSxJQUFBLGVBVVEsRUFUVixVQUFFLEVBQ0Ysd0JBQVMsRUFDVCxzQkFBUSxFQUNSLGNBQUksRUFDSiw0QkFBVyxFQUNYLHNCQUFRLEVBQ1Isa0JBQU0sRUFDTix3QkFBUyxFQUNULHdCQUNVLENBQUE7UUFDZCxJQUFNLEtBQUssR0FBRyxTQUFTLENBQUMsRUFBRSxDQUFDLElBQUksRUFBRSxDQUFBO1FBQ2pDLElBQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQTtRQUV4QixJQUFJLEdBQUcsR0FBTSxNQUFNLENBQUMsSUFBSSxTQUFJLFNBQVcsQ0FBQTtRQUN2QyxJQUFJLEtBQUssRUFBRTtZQUNQLEdBQUcsR0FBTSxHQUFHLFNBQUksTUFBTSxDQUFDLFNBQVcsQ0FBQTtTQUNyQztRQUVELE9BQU8sQ0FDSDtZQUNJLDRDQUNJLElBQUksRUFBRSxJQUFJLEVBQ1YsU0FBUyxFQUFFLEdBQUcsRUFDZCxFQUFFLEVBQUUsRUFBRSxFQUNOLEtBQUssRUFBRSxLQUFLLEVBQ1osUUFBUSxFQUFFLFVBQUMsS0FBSztvQkFDWixRQUFRLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUE7Z0JBQ3BDLENBQUMsRUFDRCxXQUFXLEVBQUUsV0FBVyxFQUN4QixRQUFRLEVBQUUsUUFBUSxFQUNsQixTQUFTLEVBQUUsU0FBUyxHQUN0QjtZQUNELFNBQVMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLElBQUksQ0FDM0IsOEJBQUMsK0JBQWMsSUFBQyxTQUFTLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxLQUFlLEdBQUksQ0FDbkU7WUFDQSxLQUFLLElBQUkscUNBQUcsU0FBUyxFQUFFLE1BQU0sQ0FBQyxLQUFLO2dCQUFHLEtBQUs7b0JBQU0sQ0FDaEQsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQTdDYSxxQkFBWSxHQUFHO1FBQ3pCLElBQUksRUFBRSxDQUFDO1FBQ1AsTUFBTSxFQUFFLEVBQUU7S0FDYixDQUFBO0lBMkNMLGVBQUM7Q0FBQSxBQS9DRCxDQUE4QixpQkFBUyxHQStDdEM7QUEvQ1ksNEJBQVEifQ==